export enum TaxExemptCertificateState {
  EXEMPT = "exempt",
  NOT_EXEMPT = "notExempt",
}
